const ntc = require("./ntc");

module.exports = ntc;



//////////////////
// WEBPACK FOOTER
// ./~/ntcjs/src/index.js
// module id = 866
// module chunks = 0